const DEFERRED_PROMPT_KEY = '__hktrainDeferredInstallPrompt__';
const INIT_FLAG_KEY = '__hktrainInstallPromptCaptureInitialized__';

export const INSTALL_PROMPT_AVAILABLE_EVENT = 'hktrain-installprompt-available';
export const APP_INSTALLED_EVENT = 'hktrain-appinstalled';

const getWindowObject = () => (typeof window !== 'undefined' ? window : null);

export const getDeferredInstallPrompt = () => {
  const win = getWindowObject();
  if (!win) {
    return null;
  }

  return win[DEFERRED_PROMPT_KEY] || null;
};

export const clearDeferredInstallPrompt = () => {
  const win = getWindowObject();
  if (!win) {
    return;
  }

  win[DEFERRED_PROMPT_KEY] = null;
};

export const initGlobalInstallPromptCapture = () => {
  const win = getWindowObject();
  if (!win || win[INIT_FLAG_KEY]) {
    return;
  }

  win[INIT_FLAG_KEY] = true;
  win[DEFERRED_PROMPT_KEY] = win[DEFERRED_PROMPT_KEY] || null;

  win.addEventListener('beforeinstallprompt', (event) => {
    // 不主動阻止瀏覽器默認流程，避免影響 Chrome 的原生安裝入口顯示
    win[DEFERRED_PROMPT_KEY] = event;
    win.dispatchEvent(new CustomEvent(INSTALL_PROMPT_AVAILABLE_EVENT));
  });

  win.addEventListener('appinstalled', () => {
    win[DEFERRED_PROMPT_KEY] = null;
    win.dispatchEvent(new CustomEvent(APP_INSTALLED_EVENT));
  });
};
